export default class Permissao {
  constructor(id, nome) {
    this.id = id
    this.nome = nome
  }
}
